var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "carousel-wrapper" },
    [
      _c(
        "swiper",
        { ref: _vm.reference, attrs: { options: _vm.options } },
        _vm._l(_vm.photos, function(photo) {
          return _c("swiper-slide", { key: photo.id }, [
            _c("img", {
              staticClass: "img-fluid",
              attrs: { src: photo.high, alt: "" }
            })
          ])
        }),
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "navigation" }, [
        _c(
          "button",
          {
            staticClass: "button-prev",
            attrs: { type: "button" },
            on: { click: _vm.prevSlide }
          },
          [_c("i", { staticClass: "icon-arrow-left" })]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button-next",
            attrs: { type: "button" },
            on: { click: _vm.nextSlide }
          },
          [_c("i", { staticClass: "icon-arrow-right" })]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }